/* eslint-disable import/no-cycle */
import { computed, decorate, observable } from 'mobx';
import { Api } from '../middleware/api';
import { EntityStore } from './entityStore';
import { Document } from '../models/document';
import i18n from '../i18n/i18n';

export class DocumentStore extends EntityStore {
  documents = [];

  get documentsWithoutExternalId() {
    return this.documents.filter((d) => !d.externalId);
  }

  constructor(rootStore) {
    super(rootStore, 'documents', Api.documents, Document);
  }

  delete(id, options = {}) {
    return super.delete(id, options).catch((e) => {
      if (e.name === 'E_FOREIGN_KEY_VIOLATION') {
        this.addMessage({type: 'error', title: i18n.t('document.errors.hasAssociations')}, {});
      }
      throw e;
    });
  }
}

decorate(DocumentStore, {
  documents: observable,
  documentsWithoutExternalId: computed,
});
